import React, { useEffect, useState } from "react";
import GroupeBienForm from '../components/Forms/GroupeBienForm';
import { DialogTitle, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchGroupeBienData, setSelectedGroupeBien } from "../reduxStore/GroupeBienSlice";
import { AppDispatch } from "../reduxStore/Store";
import { TableAction, TableHeader } from "../constants/interfaces";
import { ButtonType } from "../constants/enums";
import { GroupeBien } from "../models/models";
import MyTable from "../components/MyTable";
import { useDialog } from "../components/DialogComponent";
import DomainIcon from '@mui/icons-material/Domain';
import AppPage from '../components/layout/AppPage';
import AppSurface from '../components/layout/AppSurface';
import AppPageHeader from '../components/layout/AppPageHeader';

const GestionGropueBien: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { groupeBienData, total, loading, error, successMessage } = useSelector((state: any) => state.GropueBienSlice);
    const selectedGroupeBien = useSelector((state: any) => state.GropueBienSlice.selectedGroupeBien);
    const [fetchParams, setFetchParams] = useState({ limit: 10, offset: 0, search: '' });

    const [FormDialog, openDialog, closeDialog] = useDialog({
        dialogProps: { maxWidth: 'sm', fullWidth: true }
    });

    const handleCancel = () => {
        closeDialog();
        dispatch(setSelectedGroupeBien(null));
    };

    useEffect(() => {
        dispatch(fetchGroupeBienData(fetchParams));
    }, [dispatch, fetchParams, successMessage]);

    const headers: TableHeader<GroupeBien>[] = [
        { key: "nom", label: "Nom" },
        { key: "description", label: "Description" },
        { key: "nombre_biens", label: "Nombre Biens" },
        { key: "surface_totale", label: "Surface totale" },
    ];

    const tableActions: TableAction<GroupeBien>[] = [
        {
            label: "Edit",
            callback: (gb) => {
                dispatch(setSelectedGroupeBien(gb));
                openDialog();
            },
            type: ButtonType.EDIT,
        },
    ];

    const handlePageChange = (newPage: number, newRowsPerPage: number) => {
        setFetchParams({
            ...fetchParams,
            offset: newPage * newRowsPerPage,
            limit: newRowsPerPage,
        });
    };

    return (
        <AppPage maxWidth={false}>
            <AppPageHeader
                title="Gestion des groupes de biens"
                subtitle={`${total} groupe${total > 1 ? 's' : ''}`}
                icon={<DomainIcon />}
                addLabel="Ajouter un Groupe de biens"
                onAdd={openDialog}
            />

            {loading && <Typography color="#667085" mb={2}>Chargement...</Typography>}
            {error && <Typography color="#b42318" mb={2}>Erreur : {error}</Typography>}

            <AppSurface>
                <MyTable
                    headers={headers}
                    data={groupeBienData}
                    onPageChange={handlePageChange}
                    actions={tableActions}
                    totalRows={total}
                />
            </AppSurface>

            <FormDialog>
                <DialogTitle>
                    <Typography variant="h6">
                        {selectedGroupeBien ? 'Modifier un Groupe de biens' : 'Ajouter un Groupe de biens'}
                    </Typography>
                </DialogTitle>
                <GroupeBienForm onCancel={handleCancel} />
            </FormDialog>
        </AppPage>
    );
};

export default GestionGropueBien;
